import * as tslib_1 from "tslib";
import { AttachmentFileType } from 'owa-attachment-common';
import { lazyGetAvailableLocalAttachmentSize, } from 'owa-attachment-well-data';
import { FilePickerAction, lazyAttachmentActionsPanel, lazyGetUserPreferredFilePickerActions, SelectedFilesSource, SizeLimitInKbToSuggestSharing, } from 'owa-attachment-filepicker';
export default function getCreateAttachmentHandlerForLocalFile(viewState, createAttachment) {
    var _this = this;
    return function (files, shouldShare, isInline) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var fileObjects, i, totalSizeInBytes, availableClassicAttachmentSizeInBytes, userPreferredActions, doesFilesSizeExceedsAvailableSize, shouldSuggestSharing, shouldShowActionPanel;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fileObjects = [];
                    for (i = 0; i < files.length; i++) {
                        if (files[i].fileType === AttachmentFileType.Local) {
                            fileObjects.push(files[i].fileObject);
                        }
                        else {
                            throw new Error("Unexpected file type " + files[i].fileType);
                        }
                    }
                    totalSizeInBytes = fileObjects.reduce(function (sum, file) { return sum + file.size; }, 0);
                    return [4 /*yield*/, lazyGetAvailableLocalAttachmentSize.import()];
                case 1:
                    availableClassicAttachmentSizeInBytes = (_a.sent())(viewState);
                    return [4 /*yield*/, lazyGetUserPreferredFilePickerActions.import()];
                case 2: return [4 /*yield*/, (_a.sent())()];
                case 3:
                    userPreferredActions = _a.sent();
                    doesFilesSizeExceedsAvailableSize = totalSizeInBytes > availableClassicAttachmentSizeInBytes;
                    shouldSuggestSharing = totalSizeInBytes > SizeLimitInKbToSuggestSharing * 1024;
                    shouldShowActionPanel = false;
                    if (userPreferredActions.localComputerFiles === FilePickerAction.Attach) {
                        shouldShowActionPanel = doesFilesSizeExceedsAvailableSize;
                    }
                    else if (userPreferredActions.localComputerFiles === null) {
                        // In case user has no preferred action
                        shouldShowActionPanel = doesFilesSizeExceedsAvailableSize || shouldSuggestSharing;
                    }
                    if (!shouldShowActionPanel) return [3 /*break*/, 5];
                    return [4 /*yield*/, lazyAttachmentActionsPanel.import()];
                case 4:
                    (_a.sent())(createAttachment, fileObjects, null, SelectedFilesSource.LocalComputerFiles, availableClassicAttachmentSizeInBytes);
                    return [3 /*break*/, 6];
                case 5:
                    // We should share if the shouldShare is True or user preferred action is Share for local files
                    createAttachment(files, shouldShare || userPreferredActions.localComputerFiles === FilePickerAction.Share, isInline);
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
}
//# sourceMappingURL=getCreateAttachmentHandlerForLocalFile.js.map